import { render, staticRenderFns } from "./wareAddress.vue?vue&type=template&id=2842c3a6"
import script from "./wareAddress.vue?vue&type=script&lang=js"
export * from "./wareAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports